import { forwardRef, type Ref, type SVGProps } from "react";
const IconHighFiveFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M6.777 10.947a.9.9 0 0 1 .719.044.97.97 0 0 1 .48.558l2.377 7.086a.64.64 0 0 0 .323.347.6.6 0 0 0 .466.022.64.64 0 0 0 .352-.317.67.67 0 0 0 .046-.48l-1.963-5.853a1.01 1.01 0 0 1 .233-1.096.915.915 0 0 1 1.074-.146 1 1 0 0 1 .296.25 1 1 0 0 1 .176.35l1.963 5.853a.64.64 0 0 0 .324.347.6.6 0 0 0 .465.021.64.64 0 0 0 .351-.315.68.68 0 0 0 .046-.48l-1.13-3.393a1 1 0 0 1 .01-.774 1 1 0 0 1 .224-.322.94.94 0 0 1 .706-.255.92.92 0 0 1 .664.359q.122.156.176.35l2.17 6.47a5.4 5.4 0 0 1-.223 3.986 5.2 5.2 0 0 1-1.184 1.624 5 5 0 0 1-1.694 1.032l-1.17.424a6.1 6.1 0 0 1-4.807-.29l-5.215-2.616a.97.97 0 0 1-.48-.56 1 1 0 0 1 .042-.746.96.96 0 0 1 .54-.498.9.9 0 0 1 .72.043l1.388.696a.6.6 0 0 0 .691-.097.65.65 0 0 0 .211-.451.7.7 0 0 0-.034-.254l-2.474-7.368c-.065-.24-.04-.497.072-.719.11-.221.3-.39.527-.472a.9.9 0 0 1 .695.032c.22.102.393.287.486.517l1.968 5.847a.66.66 0 0 0 .316.399.62.62 0 0 0 .495.036.65.65 0 0 0 .423-.604.7.7 0 0 0-.047-.259L6.194 12.19a1 1 0 0 1 .043-.746.96.96 0 0 1 .537-.497z"
    />
    <path
      fill="currentColor"
      d="M20.047 10.227a.94.94 0 0 1 .915.6 1.01 1.01 0 0 1-.23 1.096l-2.396 2.589a.667.667 0 0 0 .039.896.62.62 0 0 0 .431.183.62.62 0 0 0 .434-.176l4.147-4.461a.92.92 0 0 1 1.371-.068.98.98 0 0 1 .29.714 1 1 0 0 1-.304.71l-4.148 4.461a.67.67 0 0 0 .04.897.617.617 0 0 0 .866.007l5.021-5.403a.93.93 0 0 1 .661-.297.93.93 0 0 1 .671.272h.002c.18.18.283.428.287.687a1 1 0 0 1-.263.695l-5.02 5.401a.673.673 0 0 0-.008.946.63.63 0 0 0 .466.182.6.6 0 0 0 .446-.225l4.15-4.454a.93.93 0 0 1 .65-.258c.24.002.471.1.644.273a1 1 0 0 1 .062 1.34l-5.222 5.618a.66.66 0 0 0-.177.467.67.67 0 0 0 .194.46.6.6 0 0 0 .447.177l1.541-.029a.93.93 0 0 1 .673.274c.18.18.284.427.288.686a1 1 0 0 1-.264.698.93.93 0 0 1-.662.298s-5.332.178-5.79.112c-.341-.05-1.791-.11-2.5-.138a.258.258 0 0 1-.221-.367c.327-.7 1.015-2.3 1.066-3.455.06-1.076-.45-2.384-1.038-3.994a132 132 0 0 1-1.287-3.706.25.25 0 0 1 .053-.245l.78-.861 2.223-2.262a.95.95 0 0 1 .672-.34"
    />
    <path
      fill="currentColor"
      d="M10.456 7.698a.52.52 0 0 1 .722-.125l2.48 1.542.08.068a.505.505 0 0 1 .064.644.52.52 0 0 1-.63.176l-.092-.051L10.6 8.41a.51.51 0 0 1-.144-.712"
    />
    <path
      fill="currentColor"
      d="M19.238 7.322a.51.51 0 0 1 .718.113c.16.23.1.554-.136.721l-2.312 1.785-.09.053a.51.51 0 0 1-.627-.167.52.52 0 0 1 .055-.651l.08-.069z"
    />
    <path
      fill="currentColor"
      d="M15.154 5c.285-.015.521.176.527.428l.088 3.595-.008.093c-.043.21-.248.377-.498.39s-.461-.13-.514-.335l-.013-.091-.088-3.597c-.006-.25.22-.467.506-.482"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHighFiveFilledSVG);
ForwardRef.displayName = "IconHighFiveFilled";
export { ForwardRef as IconHighFiveFilled };
